
import Header from '@/components/header/header.vue'
import SearchReuse from './children/search-reuse.vue'
import TopSearches from './children/top-searches.vue'
import {inject,  onMounted, ref} from 'vue'
import {useRouter,useRoute} from 'vue-router'
export default {
    components:{
         Header,
         SearchReuse,
         TopSearches
    },
    beforeRouteEnter(to: any, from: any, next: any){ 
     if(!common.getStorage('routerSearch')){
        common.setStorage('routerSearch',from.fullPath)      
     }
     next((vm:any)=>{   
     })
  },
    setup(){
        const $http: any = inject('$http')
        let router = useRouter()
        let route = useRoute()
        let top_searches = ref()
        let searvhValue = ref(false)
        let searvhValueList = ref()
        let refsFocus=ref()       
        let searchKeyword = ref(route.query.keyword?route.query.keyword:'')
        //搜索排行榜
        $http.get_hotSearch({term: ''}).then((res:any)=>{
            console.log('res',res);
            if(res.code === 200 ){
               top_searches.value = res.data.list
                 console.log('top_searches',top_searches.value);
            }           
        })
         //模糊搜索
        const updateValue = async (value:String)=>{         
            searvhValue.value = true 
            //在搜索组件判断就不能为空的时候关闭掉搜素关键词
            if(value !='' && value.trim()){
                 let res = await $http.get_word_auto_complete({term:value})
             if(res.code === 200){
                searvhValueList.value = res.data
             }               
            } else {
               searvhValue.value = false                 
            }                   
        } 
        //搜索跳转
         const onSearchValue = (value:string)=>{            
            if(value){
                console.log('value',value);
             router.push({
                 path:'/search',
                 query:{
                   bind_keywords:value.trim()
                 }
             })
            }           
        }
        onMounted(()=>{
              refsFocus.value.focus()            
        })
        let skipPath = ()=>{
            if(common.getStorage('routerSearch')){
                  router.push(common.getStorage('routerSearch')) 
                    common.delStorage('routerSearch')
              }
        }
        return {
             top_searches,
             updateValue,
             searvhValue,
             searvhValueList,
             onSearchValue,
             searchKeyword,
             refsFocus,
             skipPath
        }
    },
    directives: {
        focus: {
          // 指令的定义
          mounted(el:any) {             
            el.children[1].children[0].childNodes[0].autofocus = true
          }
          
        }
}
}
